<!--
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-12-05 15:00:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-08 16:18:04
 * @FilePath: \wanguo_web\common_web\src\views\archiveManager\machiveList.vue
-->
<template>
  <div class="machiveList">

    <div class="search">
      <span class="txt">{{shopName}}</span>
      <div class="seachLine">
        <el-date-picker v-model="dataAry" type="daterange" value-format="yyyy-MM-dd" range-separator="-"
          :start-placeholder="$t('complaintList.startTime')" :end-placeholder="$t('complaintList.endTime')">
        </el-date-picker>

        <el-input :placeholder="$t('applyChild.pleInputCon')" v-model="input3" class="input-with-select">
          <el-button slot="append" type="primary" @click="search"
            icon="el-icon-search">{{$t('tagsView.search')}}</el-button>
        </el-input>
      </div>
    </div>
    <div class="tablist">
      <div class="totalList">
        <div class="total">
          <span class="label">{{$t('archiveManagerMachive.totalAmount')}}：</span>
          <div class="col">
            <span class="num">{{ restotal.unit }}{{ restotal.sumPrice }}</span>
          </div>
        </div>
        <div class="total">
          <span class="label">{{$t('archiveManagerMachive.totalDuration')}}：</span>
          <div class="col">
            <span class="num">{{ restotal.sumHour }}h</span>
          </div>
        </div>
        <!-- <span>总金额:{{restotal.sumPrice}}</span>
        <span>总时长:{{restotal.sumHour}}</span> -->
      </div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="index" align="center" :label="$t('archiveManagerMachive.serialNum')" width="150">
        </el-table-column>
        <el-table-column prop="payMoney" align="center" :label="$t('archiveManagerMachive.amount')">
        </el-table-column>
        <el-table-column prop="machineHour" align="center" :label="$t('archiveManagerMachive.duration')">
        </el-table-column>
        <el-table-column prop="buyTypeTxt" align="center" :label="$t('archiveManagerMachive.type')">
        </el-table-column>
        <el-table-column prop="buyAnnotation" align="center" :label="$t('machineHourAudit.machineHourDetails')">
        </el-table-column>
        <el-table-column prop="createTime" align="center" :label="$t('archiveManagerMachive.date')">
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper" :total="totals">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { shopBuyMachinehour, } from "@/api/archive.js";
import { intermediaryBuyMachinehourReport } from "@/api/addDevice.js";

export default {
  data() {
    return {
      tableData: [],
      page: {
        current: 1,
        size: 10,
      },
      totals: 0,
      input3: "",

      checkdev: "",
      activeName: "0",
     restotal:'',
     shopName: '',
     dataAry: '',
     intermediary: false,
      buyList: [
        this.$t('reportfilter.purchase'), this.$t('reportfilter.give'),this.$t('hirePurchase.weeklyRent')
     ]
    };
  },

  mounted() {
    console.log(this.$route.query,'--this.$route.query')
    this.code = this.$route.query.id;
    this.shopName = this.$route.query.shopName
    // 只有从中介入口显式传 intermediary=true 才走中介购机时报表接口
    this.intermediary = String(this.$route.query.intermediary) === 'true'
    this.getshopBuyMachinehour();
  },
  methods: {
    getshopBuyMachinehour() {
      let obj = { ...this.page, shopCode: this.code,
      // phoneTime:'2022-12-07'
      }
      if (Array.isArray(this.dataAry)) {
        obj.startTime = this.dataAry[0]
        obj.endTime = this.dataAry[1]
      }
      const api = this.intermediary ? intermediaryBuyMachinehourReport : shopBuyMachinehour
      api(obj).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.records && res.data.data.records.length) {
             res.data.data.records.map((v,i)=>{
                  v.index = i+1
               v.buyTypeTxt = this.buyList[v.buyType-1]
              })
            this.restotal = res.data.data
            this.tableData = res.data.data.records;
            this.totals = res.data.data.total;
            this.page.current = res.data.data.current;
          } else {
            this.tableData = []
          }

        }
      });
    },
    search() {
      this.page.current = 1
       this.getshopBuyMachinehour()
    },
    handleSizeChange(e) {},
    handleCurrentChange(e) {
       this.page.current = e
       this.getshopBuyMachinehour()
    },

    goblack() {
      this.detail = false;
    },
    lookdetail(info) {
      this.checkdev = info;

      this.$nextTick(() => {
        this.detail = true;
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.machiveList {
  background: #f2f6f9;
  height: 100%;
  overflow-y: auto;

  overflow-x: hidden;
  .totalList{
    display: flex;
    height: 40px;
    align-items: center;
  }
  .total {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
    }
    .total:not(:first-child) {
        margin-left: 20px;
    }
    .label {
        color: #999999;
    }
    .col {

        color: #FD894A;
    }

.search {
  display: flex;
  background: #fff;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-content: center;
  padding-left:20px; font-weight: bold;
  .seachLine{
    display: flex;justify-content: center;
  }
  .input-with-select {
    width: 40%;margin-left: 20px;
  }

}
.head {
  display: flex;
  width: 100%;
  flex: 1;
  margin-top: 10px;
  align-items: center;
  .i1 {
    width: 4px;
    height: 18px;
    background: #50c4cb;
    border-radius: 1px;
    margin-right: 2px;
    display: inline-block;
  }
  .i2 {
    width: 2px;
    height: 18px;
    background: #50c4cb;
    border-radius: 1px;
    display: inline-block;
  }
  .con {
    flex: 1;
    font-size: 18px;
    color: #333;
    font-weight: bold;
    margin-left: 10px;
  }
}
.content {
  .list {
    background: #fff;
    padding-bottom: 10px;
    margin-bottom: 15px;
    .bnt {
      padding: 0 20px;
      text-align: end;
    }
  }

  .bold {
    font-weight: bold;
    line-height: 32px;
    // padding: 0 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .devinfo {
    padding: 15px 25px 15px 25px;

    display: flex;

    border-radius: 4px;
    align-items: center;

    &_left {
      width: 120px;
      height: 140px;
      margin-right: 20px;
    }
    &_right {
      height: 140px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      p {
        flex: 1;
        display: flex;
        width: 100%;
        font-size: 14px;
        align-items: center;
        // justify-content: space-between;
      }
    }
  }
}
.page {
  margin: 20px 0;
  text-align: end;
}
}
</style>
